module.exports = __webpack_public_path__ + "img/wancheng.52f99a40.jpeg";